let addFavorite = function(this_) {
    var url = window.location;
    var title = document.title;
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("360se") > -1) {
      this_.$message.error("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
    } else if (ua.indexOf("msie 8") > -1) {
      window.external.AddToFavoritesBar(url, title); //IE8
    } else if (document.all) {
      try {
        window.external.addFavorite(url, title);
      } catch (e) {
        this_.$message.error('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
      }
    } else if (window.sidebar) {
      window.sidebar.addPanel(title, url, "");
    } else {
      this_.$message.error('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
    }
}
let toDecimal2 = function(x) {
    var fx = parseFloat(x);
    if (isNaN(fx)) {
      return false;
    }
    var fx = Math.round(x*100)/100;
    let s = fx.toString();
    let rs = s.indexOf('.');
    if (rs < 0) {
      rs = s.length;
      s += '.';
    }
    while (s.length <= rs + 2) {
      s += '0';
    }
    return s;
}
const urlKEFU = "https://chaten.soboten.com/chat/pc/v2/index.html?sysnum=44471b4436844318a9299450b8eedcd4&channelid=21"
const FOOTER = "Paper联盟商家业务支撑平台技术支持. Copyright © 2012-" + new Date().getFullYear() +"checkpass.net All Rights Reserved"
export default {
    addFavorite,
    urlKEFU,
    FOOTER,
    toDecimal2
}


// WEBPACK FOOTER //
// ./src/commons/common.js